/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Auth_Token_HintInputs */

const cs_import_auth_token_hint = /** @type {(inputs: Import_Auth_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvoří administrátor organizace (začíná mxi_). Uloženo jen v této záložce.`)
};

const en_import_auth_token_hint = /** @type {(inputs: Import_Auth_Token_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created by an organization admin (starts with mxi_). Stored only in this browser tab.`)
};

/**
* | output |
* | --- |
* | "Created by an organization admin (starts with mxi_). Stored only in this browser tab." |
*
* @param {Import_Auth_Token_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_auth_token_hint = /** @type {((inputs?: Import_Auth_Token_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Auth_Token_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_auth_token_hint(inputs)
	return cs_import_auth_token_hint(inputs)
});